/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "underscore";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import EmsRepository from "./EmsRepository";
import PlaceholderComponent from "./PlaceholderComponent";

import * as loaderActions from "../../../store/actions/loaderActions";
import * as emsActions from "../../../store/actions/emsActions";
import APP_CONST from "../../../core/shared/constants";

const Ems = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const jwtToken = sessionStorage.getItem("jwtToken");

  const {
    generateAuditTrailInfo,
    isCancelBeforeSuccess,
    showLoaderComponentEMS,
    latestArchiveInfo,
    isCancelLoading,
    isInitialArchiveCancel
  } = useSelector((store) => store.ems);

  const {apiInitConfigObj} = useSelector((store) => store.zone);

  const [showPlaceholderComponent, setShowPlaceholderComponent] = useState(
    showLoaderComponentEMS
  );

  // eslint-disable-next-line no-unused-vars
  const { percentage, status, latest } = generateAuditTrailInfo;

  useEffect(()=>{
        let relVer = (apiInitConfigObj.releaseversion !== undefined) ? `?i=`+apiInitConfigObj.releaseversion : "";
        navigate("/ems-repo" + relVer)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[apiInitConfigObj.releaseversion])

  /* Call the Audit trail detail API
   * @dependency jwtToken
   */
  useEffect(() => {
    if (jwtToken && _.isEmpty(generateAuditTrailInfo)) {
      dispatch(emsActions.getCompleteAuditTrails(APP_CONST.TEXT_ARCHIVE));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jwtToken]);

  useEffect(() => {
    if (generateAuditTrailInfo?.percentage === 0) {
      setShowPlaceholderComponent(true);
    }

    return () => {
      dispatch(loaderActions.hideError());

      dispatch(emsActions.generateCompleteAuditTrailFailed());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (status === "Cancelled" || status === "Completed") {
      setShowPlaceholderComponent(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  /* To show and hide the placeholder component
   * Redux variable are used
   */
  useEffect(() => {
    if (
      !_.isEmpty(generateAuditTrailInfo) &&
      !isCancelBeforeSuccess &&
      status
    ) {
      if (
        percentage >= 0 &&
        percentage < 100 &&
        !["Cancelled", "Failed", "Completed"].includes(status)
      ) {
        if (
          percentage > 0 &&
          percentage < 100 &&
          ["Started", "In-Progress"].includes(status) &&
          !isCancelLoading
        ) {
          setShowPlaceholderComponent(true);
        }
        setTimeout(() => {
          dispatch(emsActions.statusCompleteAuditTrail(generateAuditTrailInfo));
        }, 3000);
      } else if (
        percentage === 100 &&
        status === "Completed" &&
        !_.isEmpty(latest)
      ) {
        setShowPlaceholderComponent(false);
        dispatch(
          loaderActions.showError(
            t("ARCHIVE.TOAST_GENERATESUCCESS"),
            "info",
            "information"
          )
        );
      } else if (status === "Failed") {
        setShowPlaceholderComponent(false);
        let findHashValue = generateAuditTrailInfo.statusmessage.includes("#");
        if (findHashValue && findHashValue === true) {
          let isUniqueIdError = generateAuditTrailInfo.statusmessage.split("#");
          if (
            isUniqueIdError &&
            isUniqueIdError[0] === "Invalid Unique Id for artifact "
          ) {
            let errormsg =
              t("ARCHIVE.TOAST_UNIQUEIDERROR") +
              isUniqueIdError
                .slice(1)
                .map((ids) => ids)
                .join("#");
            dispatch(loaderActions.showError(errormsg, "error", "warning"));
          } else {
            dispatch(
              loaderActions.showError(
                t("ARCHIVE.TOAST_GENERATESOMETHINGWENTWRONG"),
                "error",
                "warning"
              )
            );
          }
        } else {
          dispatch(
            loaderActions.showError(
              t("ARCHIVE.TOAST_GENERATESOMETHINGWENTWRONG"),
              "error",
              "warning"
            )
          );
        }
      }
    }  else if (
      !_.isEmpty(generateAuditTrailInfo) &&
      !isInitialArchiveCancel &&
      isCancelBeforeSuccess
    ) {
      dispatch(
        emsActions.cancelCompleteAuditTrail(
          {
            id: generateAuditTrailInfo.archiveId,
          },
          true
        )
      );
      dispatch(emsActions.setInitialArchiveCancel(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generateAuditTrailInfo]);

  // To cancel the already ongoing File Generation API call
  const cancelGenerateAuditTrail = () => {
    if (!_.isEmpty(generateAuditTrailInfo.archiveId)) {
      dispatch(
        emsActions.cancelCompleteAuditTrail({
          id: generateAuditTrailInfo.archiveId,
        })
      );
    } else {
      dispatch(emsActions.cancelCompleteAuditTrailBeforeSuccess());
    }
  };

  // Render the EMS Repository component in return method
  const renderEmsRepository = () => {
    return (
      <section className="archive-dashboard">
        <div className="pb-30 bb-1 pl-30 pr-30">
          <h3>{t("ARCHIVE.TEXT_ETMFEMSRESPOSITORY")}</h3>
          <p className="light-grey lh1_5">
            {t("ARCHIVE.TEXT_ARCHIVEDOWNLOADFILEGENERATEMESSAGE")}
          </p>
        </div>

        <EmsRepository
          setShowPlaceholderComponent={setShowPlaceholderComponent}
        />
      </section>
    );
  };

  //Render the Placeholder Component in return method
  const renderPlaceholder = () => {
    return (
      <PlaceholderComponent
        title={t("ARCHIVE.TEXT_GENERATEFILESEVERALMIN")}
        subTitle={t("ARCHIVE.TEXT_GENERATEDOWNLOADMSG")}
        processValue={percentage}
        setShowPlaceholderComponent={setShowPlaceholderComponent}
        cancelHandler={cancelGenerateAuditTrail}
        bottomSpinner
        loader
      />
    );
  };

  return (
    <>
      {!showPlaceholderComponent && renderEmsRepository()}
      {status !== ("Completed" || "Cancelled" || "Failed") &&
        showPlaceholderComponent &&
        renderPlaceholder()}
    </>
  );
};

export default Ems;
